/*
 * @Descripttion: 根据传入的消息，获取进行消息大小的处理
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-08-18 16:43:09
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-10-26 13:29:32
 */

var utils = require('../global/utils');
var isEmpty = utils.isEmpty;
var jsonHandler = utils.jsonHandler;
var msgSizeObj = {};
/**
 * @msg: 资源请求
 * @param {String,Function,Function} 地址，成功回调，失败回调
 * @return null
 */
var loadSource = function (url, success, fail) {
    try {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = "blob";
        xhr.onload = success;
        xhr.onerror = fail;
        xhr.send();
    } catch (e) {
        fail && fail(e);
    }

}
/**
 * @msg: 检测文件是否过期
 * @param {String,Function,Function} 
 * @return null 
 */
var checkFileValidity = function (msg, success, fail) {
    if (isEmpty(msg)) {
        return;
    }
    var msgType = msg.show_type;
    switch (msgType) {
        case 'file':
        case 'video':
        case 'image':
        case 'audio':
            loadSource(url, success, fail);
            break;

    }
}
/**
 * @msg: 收藏中对消息体进行大小的计算
 * @param {Object,Function,Function} 
 * @return null 
 */
var getMsgSize = function (msg, success, fail) {
    return new Promise((resolve, reject) => {
        if (isEmpty(msg)) {
            return;
        }
        var msgcontent = msg._original_content ? msg._original_content : msg.content;
        var msgType = msg._original_show_type || msg.show_type || msgcontent.type;
        var size = 0;
        switch (msgType) {
            case 'text':
                size = msgcontent.msg.length;
                resolve(size)
                //success && success(size);
                break;
            case 'mix':
            case 'minicard':
            case 'universal_card1':
            case 'universal_card2':
            case 'universal_card3':
            case 'universal_card4':
            case 'universal_card5':
            case 'universal_card6':
            case 'standard_evaluate_card1':
            case 'standard_evaluate_card2':
            case 'provide_contactinfo_card':
            case 'default_contactinfo_card':
                size = jsonHandler.stringify(msgcontent).length;
                resolve(size)
                break;
            case 'file':
            case 'video':
            case 'image':
            case 'audio':
                var url;
                if (msgcontent.type === 'audio') {
                    url = msgcontent.oldUrl ? msgcontent.oldUrl : msgcontent.url;
                } else if (msgcontent.type === 'image') {
                    url = msgcontent.url;
                    url = url.replace('http:', '')
                } else {
                    url = msgcontent.url;
                }

                if (msgSizeObj[url] || (!isEmpty(msgcontent.size) && msgcontent.size > 0)) {
                    msgSizeObj[url] = !isEmpty(msgSizeObj[url]) ? msgSizeObj[url] : msgcontent.size;
                    resolve(msgSizeObj[url])
                    //success && success(msgSizeObj[url]);
                } else {
                    loadSource(url, function (res, textStatus, request) {
                        // 火狐浏览器等不支持获取content-length
                        var responseSize = this.response && this.response.size ? this.response.size : null;
                        if (!isEmpty(responseSize)) {
                            msgSizeObj[url] = size;
                            resolve(msgSizeObj[url])
                        } else {
                            reject({
                                error_code: 405,
                                error_msg: '获取文件大小未知错误'
                            })
                        }
                    }, function (err, textStatus, request) {
                        if (err && err.status == '404') {
                            reject({
                                error_code: 404,
                                error_msg: '文件不存在',
                                err
                            })
                            //fail && fail({ error_code: 404, err });
                        } else {
                            reject({
                                error_code: 405,
                                error_msg: '获取文件大小未知错误',
                                err
                            })
                        }
                    });
                }
                break;
            default:
                size = jsonHandler.stringify(msgcontent).length;
                resolve(size)
                break;

        }
    })
}
/**
 * @msg: 延长文件和音频、视频等的有效时间
 * @param {Object,Function,Function}} 
 * @return null
 */
var extendMsgValidity = function (wosInfo, data, msg) {
    return new Promise((resolve, reject) => {
        var msgcontent = msg._original_content ? msg._original_content : msg.content;
        if (['video', 'audio', 'file'].indexOf(msgcontent.type) == -1) {
            return resolve()
            //return success && success();
        }
        var urlArr = [];
        var splitString = msgcontent.url.indexOf(wosInfo.WOS_CLIENT_APP_ID) != -1 && wosInfo.WOS_CLIENT_URL ? wosInfo.WOS_CLIENT_URL : wosInfo.WOS_CDN_URL ? wosInfo.WOS_CDN_URL : '';
        var splitArr = decodeURIComponent(msgcontent.url).split(splitString);
        var urlArr = !isEmpty(splitString) && splitArr.length > 1 ? splitArr[1].split('/') : !isEmpty(splitString) && splitArr.length > 0 ? splitArr[0].split('/') : [];
        if (urlArr.length == 0) {
            reject({
                error_code: 406,
                error_msg: '文件源地址无法延期'
            });
            return;
        }
        var wos_file_name = msgcontent.wos_file_name ? msgcontent.wos_file_name : msgcontent.url.indexOf(wosInfo.WOS_CLIENT_APP_ID) != -1 ? urlArr[8] || urlArr[5] : urlArr[3];
        var WOS_APP_ID = msgcontent.url.indexOf(wosInfo.WOS_CLIENT_APP_ID) != -1 ? wosInfo.WOS_CLIENT_APP_ID : urlArr[1];
        var urlLen = urlArr.length;
        var urlBucket;
        if (isEmpty(WOS_APP_ID) && urlLen > 3) {
            WOS_APP_ID = urlArr[urlLen - 3];
            urlBucket = urlArr[urlLen - 2];
        }
        var wos = new WosSys({
            appid: WOS_APP_ID,// APPID 必填参数
            bucket: data.bucket,//bucketName 必填参数
            wosurl: msgcontent.url.indexOf(wosInfo.WOS_CLIENT_APP_ID) != -1 && wosInfo.WOS_CLIENT_URL ? wosInfo.WOS_CLIENT_URL : wosInfo.WOS_URL ? wosInfo.WOS_URL : '',//wos的url 必填参数
            getAppSign: function (callback) {//获取签名 必填参数
                callback(encodeURIComponent(data.wos_token));
            }
        });
        var params = {
            bucketName: data.bucket,               // 文件bucket
            remotePath: wos_file_name,    // 文件路径
            ttl: data.no_extendMsgValidity ? data._wos_file_expire : data.extend_wos_file_expire ? data.extend_wos_file_expire : 0,                         // 文件过期时间
            onUploadProgress: function (res) {
            },   // 文件上传失败回调
            onUploadSuccess: function (res) {
                resolve(res)
                // success && success();
            },    // 文件上传成功回调
            onUploadError: function (err) {
                // 不同source发过来的文件，不能进行延期
                if (urlBucket && urlBucket !== data.bucket && data.no_extendMsgValidity) {
                    resolve();
                    return;
                }
                reject({
                    error_code: err.status ? err.status : '404',
                    error_msg: '设置文件有效期，上传文件错误',
                    err
                })
                // fail && fail();
            }       // 文件上传中回调
        };
        wos.setFileTtl(params);
    })
}

module.exports = {
    getMsgSize,
    extendMsgValidity
}
